<template>
  <div>
    <vx-card title="ข้อมูลทั่วไป">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-tabs>
            <vs-tab label="ข้อมูลสัญญา">
              <ContractInfoTab></ContractInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลฝ่ายติดตามหนี้">
              <UserJobInfoTab></UserJobInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลฝ่ายกฎหมาย">
              <LawyerJobInfoTab></LawyerJobInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลไฟล์แนบ">
              <FileInfoTab></FileInfoTab>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import {ICaseStatus} from "@/constants/interface";
const { mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')
import prosecutionTimeline from "@/views/components/custom/ProsecutionTimeline.vue";
import ContractInfoTab from "@/views/pages/Prosecution/Transaction/components/components/ContractInfoTab.vue";
import UserJobInfoTab from "@/views/pages/Prosecution/Transaction/components/components/UserJobInfoTab.vue";
import LawyerJobInfoTab  from "@/views/pages/Prosecution/Transaction/components/components/LawyerJobInfoTab.vue";
import FileInfoTab from "@/views/pages/Prosecution/Transaction/components/components/FileInfoTab.vue";

export default {
  name: "GeneralInformation",
  components: {
    prosecutionTimeline,
    ContractInfoTab,
    UserJobInfoTab,
    LawyerJobInfoTab,
    FileInfoTab
  },
  computed: {
    ...mapProsecutionFields(['prosecution']),
    _prosecution() {
      if(!this.prosecution) return null
      return this.prosecution
    },
    prosecutionId(){
      return this.$route.params.id
    },
    visibilityEdit(){
      const caseStatuses = [ICaseStatus.draft, ICaseStatus.sendInformationContractToLawyer, ICaseStatus.cancelCase, ICaseStatus.closeCase];
      return !caseStatuses.includes(this.prosecution.caseStatus);
    }
  },
}
</script>

